module.exports = __webpack_public_path__ + "img/智慧荔园.fd43a7ca.png";